import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GatewayCreateComponent } from './gateway-create/gateway-create.component';
import { GatewaySetupService } from './gateway-setup.service';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { GatewayListComponent } from './gateway-list/gateway-list.component';

const routes: Routes = [
  {
    path: '',
    component: GatewayCreateComponent,
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes)
  ],
  providers: [
    GatewaySetupService
  ],
  declarations: [GatewayCreateComponent, GatewayListComponent]
})
export class GatewaySetupModule { }



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/gateway-setup/gateway-setup.module.ts